var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{attrs:{"options":_vm.options,"load-data":_vm.loadData,"default-value":_vm.defaultValue,"field-names":{ label: 'name', value: 'id', children: 'children' },"placeholder":_vm.placeholder,"change-on-select":""},on:{"change":_vm.onAreaChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }